// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"869":"f4cf5097","962":"9a1ba80f"}[chunkId] + ".chunk.css";
};